import React from "react";
import { Header, Icon, Segment } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import messages from "./messages";

export const EmptyState = () => {
  return (
    <div id="emptyState">
      <Segment placeholder>
        <Header icon>
          <Icon name="search" />
          <FormattedMessage {...messages.empty} />
        </Header>
      </Segment>
    </div>
  );
};

export default EmptyState;
